"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultTheme = void 0;
var _styles = require("@material-ui/core/styles");
var rootTheme = {
  fontFamily: ["Roboto", "sans-serif"],
  colors: {
    black: '#000000',
    borderGrey: '#e8e8e8',
    // used as borders
    grey: '#666666',
    accent: '#794bc4',
    // default purple
    brand: '#8AA4FF',
    red: '#e21e5c',
    white: '#ffffff',
    backgroundGrey: '#f9f9f9',
    // used as background grey
    lightGrey: '#dddddd',
    disabledGrey: '#999999',
    greyMedium: "#383B3D",
    overlayGrey: "#D9D9D9",
    filterBackgroundGrey: '#FCFCFA',
    filterActiveBlue: '#136EF6',
    filterActiveBackgroundBlue: 'rgba(34, 83, 255, 0.1)',
    filterChipBackgroundGrey: '#EBEDEF',
    transparent: 'transparent',
    backgroundColor: "#1F2021",
    mainTextColor: "#ffffff"
  },
  zIndex: {
    VNBackdropSystem: 2000
  }
};
var defaultTheme = function defaultTheme() {
  return getTheme();
};
exports.defaultTheme = defaultTheme;
var getTheme = function getTheme() {
  return (0, _styles.createTheme)({
    palette: {
      primary: {
        main: '#2253ff'
      },
      secondary: {
        main: '#fff'
      },
      error: {
        main: rootTheme.colors.red
      },
      disabled: {
        main: rootTheme.colors.disabledGrey
      }
    },
    custom: {
      colors: rootTheme.colors,
      zIndex: rootTheme.zIndex,
      button2: {
        // use for Custom Tip and No Tip
        fontFamily: rootTheme.fontFamily,
        fontSize: 24,
        fontWeight: 400,
        lineHeight: '28px',
        height: 65
      },
      button3: {
        // 15%, 20%
        fontFamily: rootTheme.fontFamily,
        fontSize: 32,
        fontWeight: 500,
        lineHeight: '37.5px',
        height: 82
      },
      button4: {
        // email receipt
        fontFamily: rootTheme.fontFamily,
        fontSize: 22,
        height: 64,
        fontWeight: 700,
        lineHeight: '25.78px',
        color: rootTheme.colors.white
      },
      button5: {
        // save and cancel on vndialog
        fontFamily: rootTheme.fontFamily,
        fontSize: 24,
        height: 95,
        fontWeight: 700,
        lineHeight: '28px',
        color: rootTheme.colors.white,
        borderRadius: 0,
        borderRight: '1px solid black',
        borderBottom: 0,
        backgroundColor: rootTheme.colors.transparent,
        padding: 0,
        marginTop: 0
      },
      button6: {
        // Pay
        fontFamily: rootTheme.fontFamily,
        fontSize: 20,
        fontWeight: 700,
        lineHeight: '23.44px',
        color: rootTheme.colors.white,
        height: 48
      },
      defaultDialog: {
        width: '48%',
        height: '47%'
      },
      defaultSnackbar: {
        width: '35%',
        textAlign: 'left'
      },
      buttonContainer: {
        // save and cancel on vndialog
        borderRadius: 0,
        borderTop: '1px solid black',
        backgroundColor: rootTheme.colors.transparent,
        padding: 0
      },
      subtitle3: {
        // subtotal etc
        fontFamily: rootTheme.fontFamily,
        fontSize: 18,
        lineHeight: '21px',
        fontWeight: 400,
        color: rootTheme.colors.white
      },
      subtitle4: {
        // Large (4 cheese pizza)
        fontFamily: rootTheme.fontFamily,
        fontSize: 20,
        lineHeight: '23px',
        fontWeight: 400,
        color: rootTheme.colors.disabledGrey
      },
      large1: {
        // use for $180
        fontFamily: rootTheme.fontFamily,
        fontSize: 40,
        fontWeight: 700,
        lineHeight: '46.88px',
        color: rootTheme.colors.white
      },
      defaultPadding: 8
    },
    typography: {
      fontFamily: rootTheme.fontFamily,
      button: {
        fontFamily: rootTheme.fontFamily,
        fontSize: 16,
        lineHeight: '18px',
        fontWeight: 600,
        textTransform: 'normal',
        color: rootTheme.colors.accent
      },
      h1: {
        // church chicken
        fontFamily: rootTheme.fontFamily,
        fontSize: 60,
        fontWeight: 700,
        lineHeight: '83px',
        color: rootTheme.colors.white
      },
      h2: {
        fontFamily: rootTheme.fontFamily,
        fontSize: 22,
        lineHeight: '25.78px',
        fontWeight: 700,
        color: rootTheme.colors.white
      },
      h3: {
        // 4 cheese pizza
        fontFamily: rootTheme.fontFamily,
        fontSize: 32,
        fontWeight: 700,
        lineHeight: '37px',
        color: rootTheme.colors.white
      },
      h5: {
        fontFamily: rootTheme.fontFamily,
        fontSize: 20,
        fontWeight: 400,
        lineHeight: '23.44px',
        color: rootTheme.colors.white
      }
    }
  });
};